module.exports = __webpack_public_path__ + "static/img/11.b5cb42d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/sp/11.png
// module id = wdlK
// module chunks = 0